import type { IconDef } from '../types';

export const pause: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M12 0C18.6218 0 24 5.37818 24 12C24 18.6218 18.6218 24 12 24C5.37818 24 0 18.6218 0 12C1.93648e-07 5.37818 5.37818 1.93642e-07 12 0ZM17.1816 3.66504C12.9271 1.0144 7.14522 2.59667 4.28711 7.2002C1.4291 11.8038 2.56388 17.695 6.81836 20.335C11.0729 22.9747 16.8548 21.3817 19.7129 16.7891V16.7998C22.5709 12.1962 21.4361 6.305 17.1816 3.66504ZM9.81836 6.5459C10.4183 6.546 10.9092 7.03678 10.9092 7.63672V15.5674C10.9091 16.1673 10.4182 16.6581 9.81836 16.6582C9.2184 16.6582 8.7276 16.1673 8.72754 15.5674V7.63672C8.72754 7.03672 9.21836 6.5459 9.81836 6.5459ZM15.2725 6.5459C15.8725 6.5459 16.3633 7.03672 16.3633 7.63672V15.5674C16.3632 16.1673 15.8724 16.6582 15.2725 16.6582C14.6726 16.6581 14.1817 16.1672 14.1816 15.5674V7.63672C14.1816 7.03681 14.6726 6.54604 15.2725 6.5459Z',
    },
  ],
};
